import React, { useState } from 'react';
import FormSkel from './FormSkel';
import { NotificationManager } from 'react-notifications';

export default function DepositForm({ handleClose, handleSubmit, depositData }) {
  const [data, setData] = useState(
    depositData || { Name: '', EAN: '', Price: '', IsActive: true }
  );
  
  const [initialData] = useState(
    depositData || { Name: '', EAN: '', Price: ''}
  );

  const onChange = (field) => (e) => {
    let val = e.target.value;
    if (field === 'EAN') {
      val = val.replace(/[^\d]/g, '');
    }
    if (field === 'Price') {
      val = val.replace(',', '.');
    }
    setData(prev => ({ ...prev, [field]: val }));
  };

  const isUnchanged = Object.keys(initialData).every(
    key => String(data[key]) === String(initialData[key])
  );

  return (
    <FormSkel
      headerText={depositData ? 'Edytuj kaucję' : 'Nowa kaucja'}
      onKeyDown={evt => evt.key === 'Enter' && evt.preventDefault()}
      data={data}
      deleteDisable={depositData ? false : true}
      handleClose={handleClose}
      handleSubmit={evt => handleSubmit(evt, setData)}
      disableSubmit={!data.Name || !data.EAN || data.Price === '' || isUnchanged || Number(data.Price) < 0}
    >
      <form
        autoComplete="off"
        id="modal-form"
        onKeyDown={evt => evt.key === 'Enter' && evt.preventDefault()}
        onSubmit={evt => handleSubmit(evt, setData)}
      >
        <div className="mb-3">
          <label className="h6">Nazwa</label>
          <input
            autoComplete="off"
            minLength={1}
            name="name"
            className={`form-control ${!data.Name && 'invalid-input'}`}
            value={data.Name}
            maxLength={200}
            onChange={onChange('Name')}
            onFocus={() => setData(prev => ({ ...prev, Name: '' }))}
          />
        </div>

        <div className="mb-3">
          <label className="h6">EAN</label>
          <input
            autoComplete="off"
            name="ean"
            className={`form-control ${!data.EAN && 'invalid-input'}`}
            value={data.EAN}
            maxLength={18}
            onChange={onChange('EAN')}
            inputMode="numeric"
          />
        </div>

        <div className="mb-3">
          <label className="h6">Cena</label>
          <input
            autoComplete="off"
            name="price"
            className={`form-control ${data.Price === '' && 'invalid-input'}`}
            value={data.Price}
            onChange={onChange('Price')}
            inputMode="decimal"
            maxLength={8}
            placeholder="0.00"
          />       
        </div>
      </form>
    </FormSkel>
  );
}
